import React, { useState, useEffect } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import TermsAndConditions from './TermsAndConditions';
import { resolveAppSub } from '../utils/appIdentity';

const TermsAndConditionsCheck = ({ children }) => {
  const [showTerms, setShowTerms] = useState(false);
  const [loading, setLoading] = useState(true);
  const { authStatus, user } = useAuthenticator((context) => [context.authStatus, context.user]);

  useEffect(() => {
    if (authStatus === 'authenticated' && user) {
      checkTermsAcceptance();
    } else {
      setLoading(false);
    }
  }, [authStatus, user]);

  const checkTermsAcceptance = async () => {
    try {
      setLoading(true);
      
      // Resolve which row holds this person's acceptance. The token's sub alone misses for anyone
      // migrated to the FITTWorks hub pool and not yet remapped, and a miss here reads as "has not
      // accepted" — so the modal reappeared for people who had accepted long ago.
      const { user: dbUser } = await resolveAppSub(user);

      // Check if terms have been accepted
      if (dbUser && dbUser.termsAccepted) {
        setShowTerms(false);
      } else {
        setShowTerms(true);
      }
      
      setLoading(false);
    } catch (error) {
      console.error('Error checking terms acceptance:', error);
      setLoading(false);
    }
  };

  const handleTermsAccept = () => {
    setShowTerms(false);
  };

  // IMPORTANT: {children} (the entire AppRouter tree) is kept mounted at all
  // times. We intentionally do NOT replace it with a spinner while checking
  // terms — doing so unmounted and remounted the whole app when auth state
  // settled (configuring -> authenticated), which made OrganizationSelector's
  // spinners flash on refresh. Instead we show the loading state as an overlay.
  //
  // The overlay only appears for authenticated users mid-check, so public /
  // unauthenticated pages are unaffected. Authenticated routes handle the
  // configuring/loading states themselves (see AuthWrapper), so rendering them
  // underneath the overlay is safe.
  return (
    <>
      {children}

      {loading && authStatus === 'authenticated' && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ position: 'fixed', inset: 0, backgroundColor: '#fff', zIndex: 2000 }}
        >
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {authStatus === 'authenticated' && showTerms && (
        <TermsAndConditions
          onAccept={handleTermsAccept}
          onClose={() => {}} // We don't allow closing without accepting
        />
      )}
    </>
  );
};

export default TermsAndConditionsCheck; 